const POI_VIEW_ID_DESKTOP = 'poiViewDesktop'
const POI_VIEW_ID_MOBILE = 'poiViewMobile'

export {
  POI_VIEW_ID_DESKTOP,
  POI_VIEW_ID_MOBILE
}
